<template lang="pug">
  v-app(id="app")
    v-content
      Navbar
      v-container(fluid, style="padding:0")
        .sign
          Cover(:logo="icons.logo")
          .sign-col-two.g-flex.g-align-center
            .sign-col-two-container
              section.sign-col-two-main
                article(ref="formLogin")
                  h2.omnesMedium
                    span.omnesSemibold ¡Hola!&nbsp;
                    | Inicia tu sesión
                  h3 Ingresa tu documento de identidad
                  .sign-col-two-input
                    v-text-field(label="DNI/CE", outline, v-model="txtUserLogin", browser-autocomplete="off", maxlength="20", @keypress="alphanumericValidation", @keyup="getUserLogin", @click="scrollToForm")
                    v-text-field.eye-password(label="Contraseña", :type="typePassword", outline, browser-autocomplete="off", hide-details, v-model="txtPassLogin", @keyup="getPassLogin")
                      template(v-slot:append='')
                        img(:src="icons.eyeSelected", alt="eyeClose", @click="showHidePassword()")
                  button.omnesRegular.zs-btn-fill.fuchsia.sign-btn-login(@click="login") Ingresar
                  button.omnesRegular.zs-btn-fill.skyblue.sign-btn-create-user(@click="createAccount") Regístrate
                  p.omnesMedium.zs-btn-inline-blue.forgot-pass.text-xs-center.cursor-pointer(@click="goToRecoveryPassword") Olvidé mi contraseña

    //- POPUP ALERTA GENÉRICO (error de validación frontend)
    PopupAlertMessage(
      @closeAlertPopup="closeAlertPopupMethod"
      :openPopup="flagPopupAlert"
      :image="infoPopup.img"
      :title="infoPopup.title"
      :message="infoPopup.message"
      :messageButton="infoPopup.messageButton"
    )

    //- LOADER LOGIN
    v-layout
      v-dialog(v-model="loading" persistent width="300")
        v-card(color="primary" dark="")
          v-card-text
            | Ingresando...
            v-progress-linear.mb-0(indeterminate="" color="white")

    //- LOADER REGISTRO
    v-layout
      v-dialog(v-model="loadingRegistro" persistent width="300")
        v-card(color="primary" dark="")
          v-card-text
            | Corroborando...
            v-progress-linear.mb-0(indeterminate="" color="white")

    //- MODAL ERROR CUENTA (flujo registro)
    PopupAlertMessage(
      @closeAlertPopup="goToSignUp()"
      :openPopup="error.showModal"
      :image="icons.createAccount"
      :title="error.title"
      :message="error.parraf"
      :messageButton="'Entendido'"
      :buttonClose="true"
    )

    //- MODAL ERROR GENÉRICO (documento inválido, validaciones frontend)
    PopupAlertMessage(
      @closeAlertPopup="dismissModal()"
      @secondButtonClick="goToSignUp()"
      :openPopup="error.showModalGeneric"
      :image="icons.oops"
      :title="error.title"
      :message="error.parraf"
      :messageButton="error.messageButton"
      :secondButton="error.secondButton"
    )

    //- MODAL BLOQUEO POR INTENTOS (BLOQUEO_INTENTOS)
    LockAttemptsModal(
      :open="lockInfo.showCountdown && lockInfo.lockType === 'BLOQUEO_INTENTOS'"
      :lockMessage="lockMessage"
      @go-to-register="goToRegister"
      @go-to-recovery="goToRecoveryPassword"
    )

    //- MODAL INTENTOS FALLIDOS (1er y 2do intento)
    FailedAttemptModal(
      :open="failedAttempt.showModal"
      :title="failedAttempt.title"
      :body="failedAttempt.body"
      :secondaryButtonText="failedAttempt.secondaryButtonText"
      @retry="retryLogin"
      @secondary-action="handleFailedAttemptSecondaryAction"
    )

    //- MODAL PROMOCIÓN
    v-dialog(v-model="promotions.participa", width="500", persistent)
      v-card.sign-in-modal.promotions
        figure.text-xs-center
          img(:src="icons.promotions" alt="iconPromotions" width="40%")
        h2.text-xs-center(style="font-size: 20px;color:#0855C4")
          | ¡Participa por un
          br
          | <b>vale virtual de S/200</b>!
        br
        p.text-xs-center
          | Registrate en Zona Segura tu plataforma
          br
          | de usuario del 20 al 30 de junio y participa
          br
          | del sorteo ¡<b>Son 10 ganadores</b>!
        br
        p.text-xs-center(style="font-size: 12px;")
          | * Aplica para los clientes que cuenten
          br
          | con un <strong>Seguro de Vida</strong>.
        button.transition-all-3.hover-scale(@click="promotions.participa = false") ¡Participa ya!

    //- MODAL INCONVENIENTES
    v-dialog(v-model="inconvenientes", width="500", persistent)
      v-card.sign-in-modal.promotions
        figure.text-xs-center
          img(:src="icons.oops" alt="iconoInconvenientes" width="40%")
        br
        p.text-xs-center
          | En estos momento estamos presentando incovenientes con el ingreso. Estamos trabajando para solucionarlo lo más pronto posible.
</template>

<script>
import loginMixin from '../mixins/login.mixin'
import loginLockHandlerMixin from '../mixins/login-lock-handler.mixin'
import PopupAlertMessage from '../components/PopupAlertMessage.vue'
import FailedAttemptModal from '../components/login/FailedAttemptModal.vue'
import LockAttemptsModal from '../components/login/LockAttemptsModal.vue'
import Navbar from '@/components/login/Navbar'
import Cover from '@/components/login/Cover'

export default {
  mixins: [loginMixin, loginLockHandlerMixin],
  data () {
    return {
      icons: {
        logo: require('@/assets/logo.svg'),
        phone: require('./../assets/cvc/icon_phone.svg'),
        message: require('./../assets/cvc/icon_message.svg'),
        createAccount: require('./../assets/iconsv6/crear_cuenta.svg'),
        eyeSelected: require('@/assets/icons/icon-eye-close.svg'),
        eyeClose: require('@/assets/icons/icon-eye-close.svg'),
        eyeOpen: require('@/assets/icons/icon-eye-open.svg'),
        oops: require('@/assets/characters/oops.svg'),
        aviso: require('@/assets/characters/informa.svg'),
        error: require('@/assets/characters/sorprendido.svg'),
        alerta: require('@/assets/characters/alerta.svg'),
        promotions: require('./../assets/new-home/promotions/interseguro-agora.gif')
      }
    }
  },
  mounted () {
    this.initLoginPage()
  },
  components: {
    PopupAlertMessage,
    FailedAttemptModal,
    LockAttemptsModal,
    Navbar,
    Cover
  }
}
</script>

<style>
@import url('../assets/css/general.css');

.layout-public-header.login {
  background-color: rgba(255, 255, 255, 0.10);
  position: fixed;
  width: 100%;
  transition: all 0.4s ease-out;
  z-index: 1;
}

.layout-public-header.login.bg-color-is {
  background-color: var(--first-brand-color);
}

.sign-col-two-input .v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
.sign-col-two-input .v-text-field .v-input__control .v-input__slot,
.sign-col-two-input .v-text-field .v-input__control .v-input__slot:hover {
    border: 1px solid #C4C4C4 !important;
    margin-bottom: 16px;
}
.sign-col-two-input .v-text-field .v-input__control .v-input__slot label {
  color: #C4C4C4;
}
.sign-col-two-input .v-text-field .v-input__control .v-input__slot .v-text-field__slot input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px white inset;
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}

.sign-in-modal.promotions h2 {
  font-weight: normal;
  line-height: 1.2;
}
.sign-in-modal.promotions p {
  font-size: 16px;
}
.sign-main img {
  max-width: 93%;
}

.sign input {
  font-family: "Omnes Regular", sans-serif;
}

.sign-btn-login {
  margin-bottom: 18px;
  margin-top: 7px;
}
.sign-btn-create-user {
  margin-bottom: 30px;
}
.sign-col-two-container {
  margin: auto;
  width: 90%;
}
.sign-col-two-main {
  margin-left: auto;
  margin-right: auto;
  max-width: 500px;
}
.sign-col-two-main article {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  max-width: 95%;
}
.sign-col-two-main article h2,
.sign-col-two-main article h2 span {
  color: var(--first-brand-color);
  font-weight: normal;
  font-size: 24px;
}
.sign-col-two-main article h3 {
  color: var(--text-color);
  font-weight: normal;
  font-size: 16px;
  margin: 5px 0 30px;
}

.sign-col-two-main article .forgot-pass {
  margin: 0 auto 13%;
}
.sign-remember-password {
  position: relative;
  margin-top: 8px;
  margin-bottom: 30px;
}
.sign-remember-password label {
  cursor: pointer;
  margin-left: 25px;
  font-size: 1em;
}
.sign-remember-password label:after,
.sign-remember-password label:before {
  content: '';
  top:50%;
  position: absolute;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
}
.sign-remember-password label:after {
  border: 2px solid white;
  border-top: none;
  border-right: none;
  height: 5px;
  left: 4px;
  opacity: 0;
  transform:  translateY(-50%) rotate(-45deg);
  width: 9px;
}
.sign-remember-password input {
  left: 0;
  height: 20px;
  top:50%;
  position: absolute;
  transform: translateY(-50%);
  visibility: hidden;
  width: 20px;
}
.sign-remember-password label:before {
  border: 1px solid#B1B8C4;
  border-radius: 50%;
  height: 16px;
  left: 0;
  transform: translateY(-50%);
  width: 16px;
}
.sign-create-user-data {
  margin-left: auto;
  margin-right: auto;
  max-width: 180px;
}
.sign-remember-password input:checked ~ label:before {
  background-color: var(--second-brand-color);
  border-color: var(--second-brand-color);
}
.sign-remember-password input:checked + label:after {
  opacity: 1;
}
.sign-send-code{ width: 200px; }
.sign-email-phone label {
  background: #DADBE2;
  height: 65px;
  position: relative;
}
.sign-email-phone input {
  left: 0;
  height: 20px;
  top:50%;
  position: absolute;
  transform: translateY(-50%);
  visibility: hidden;
  width: 20px;
}
.sign-email-phone span{
  display: block;
  font-weight: bold;
}
.sign-email-phone p:after,
.sign-email-phone p:before {
  content: '';
  position: absolute;
  top: 50%;
}
.sign-email-phone p:after {
  border: 2px solid white;
  border-top: none;
  border-right: none;
  height: 6px;
  left: 21px;
  opacity: 0;
  transform:  translateY(-50%) rotate(-45deg);
  width: 12px;
}
.sign-email-phone p:before {
  border: 1px solid var(--text-color);
  border-radius: 50%;
  height: 23px;
  left: 15px;
  transform: translateY(-50%);
  width: 23px;
}
.sign-email-phone p {
  padding-left: 55px;
}
.sign-email-phone input:checked ~ p:before {
  background-color: #0855C4;
  border-color: #0855C4;
}
.sign-email-phone input:checked ~ p:after {
  opacity: 1;
}
.sign-email-phone input:checked ~  p span {
  color: #0855C4
}
.sign-code {
  background: #F5F7FD;
}
.sign-code div {
  justify-content: space-evenly;
}
.sign-code input {
  align-items: center;
  background: white;
  border: 1px solid var(--text-color);
  border-radius: 5px;
  display: flex;
  font-weight: bold;
  height: 40px;
  font-size: 18px;
  justify-content: center;
  padding-left: 14px;
  width: 35px;
}
.sign-verify-data .v-input__control {
  height: 73px!important;
}
.sign-btn-verify-data {
  cursor: pointer;
  width: 180px;
}
.sign-question-verify h3 {
  font-size: 0.98rem;
}
.sign-question-verify .g-flex {
  justify-content: space-between;
}
.sign-question-verify .g-flex p {
  align-items: center;
  background: #F5F7FD;
  cursor: pointer;
  display: flex;
  font-size: 0.85rem;
  justify-content: center;
  margin-top: 10px;
  padding: 7px 0;
  text-align: center;
  width: 80px;
}
.sign-in-modal {
  background: white;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  top:15%;
  padding: 20px;
  position: absolute;
  max-width: 100%;
  width: 320px;
  max-width: 100%;
  z-index:999;
}
.hover-scale:hover {
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.sign-in-modal img {
  max-width: 100%;
}
.sign-in-modal h2 {
  font-size: 1.6rem;
  margin: 10px auto 0 auto;
}
.sign-in-modal button {
  align-items: center;
  background: var(--fuchsia-color);
  color: white;
  display: flex;
  height: 50px;
  justify-content: center;
  margin: 30px auto 20px auto;
  width: 180px;
  font-family: "Omnes Medium";
  font-size: 15px;
}
.v-input.eye-password .v-input__control .v-input__slot .v-input__append-inner {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  align-self: center;
  flex-direction: column;
  margin: 0;
}
.v-input.eye-password .v-input__control .v-input__slot .v-input__append-inner img {
  width: 55% !important;
  cursor: pointer;
}

/* Small to large handset ----------- */
@media only screen and (max-width: 600px) {
  .sign-remember-password {
    margin-bottom: 20px;
  }
}
@media screen and (max-height: 768px) {
  .sign-in-modal{
    top: 20px;
  }
}
@media screen and (max-width: 1023px) {
  .sign-col-two {
    background-image: url('../assets/login/bg-white-mobile.svg');
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: -50px;
  }

  .sign-col-two-main article h2,
  .sign-col-two-main article h2 span,
  .sign-col-two-main article h3 {
    text-align: center;
  }
}

@media screen and (min-width: 600px) {
  .sign-col-two {
    background-size: cover;
    margin-top: -80px;
  }
}

@media screen and (min-width: 768px) {
  .sign-btn-login {
    margin-top: 15px;
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 1024px) {
  .sign {
      display:flex;
  }
  .sign-col-two {
    margin-top: 0;
    min-height: 670px;
    height: 100vh;
    width: 50%;
  }

  .sign-col-two-main article {
    margin-top: 8%;
    max-width: 73%;
  }
  .sign-col-two-main article h3 {
    margin: 0 0 18px;
  }

  .sign-col-two-input .v-text-field .v-input__control .v-input__slot {
      margin-bottom: 20px !important;
  }

  .sign-in-modal{
    width: 400px;
  }
  .sign-in-modal h2{
    font-size: 1.8rem;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue